import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataNotFound, Loader, CourseCard } from "../../components";
import { dataMessage } from "../../helpers/messages";
import { routes } from "../../helpers/constants";
import { reqToGetCourseModuleList } from "../../store/slice/coursesSlice";

const CourseModules = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { sCourse } = location?.state || {};
  const { loader, courseModuleList } = useSelector(
    (state) => state.coursesReducer
  );

  useEffect(() => {
    if (sCourse && sCourse?.id) {
      if (Array.isArray(courseModuleList) && courseModuleList?.length > 0) {
        return;
      }
      dispatch(
        reqToGetCourseModuleList({
          data: { course_id: sCourse?.id },
          onSuccess: () => {},
          dispatch,
        })
      );
    } else {
      navigate(routes.courses);
    }
  }, [sCourse]);

  const handleSelectModule = (module) => {
    navigate(routes.moduleViewing, { state: { sModule: module,title: module?.title } });
  };

  return (
    <>
      {loader && <Loader />}
      <div className="lms-body">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="lms-profile-wrapper mb-0">
            <span className="lms-profile-name">LIST OF MODULES</span>
          </div>
        </div>
        <div className="lms-content-wrapper lms-content-text">
          <div className="lms-course text-end fs-18 fw-600 mb-3 pb-2">
            Total Modules: {courseModuleList?.length || 0}
          </div>
          <div className="overflow-y lms-ceontent-course">
            <div className="row g-4">
              {Array.isArray(courseModuleList) &&
              courseModuleList?.length > 0 ? (
                courseModuleList.map((course, index) => (
                  <div
                    className="col-12 col-md-6 col-xl-4 lms-cousrse-cards"
                    key={index}
                  >
                    <CourseCard
                      course={course}
                      type="modules"
                      count={course?.module_data?.length || 0}
                      onClick={handleSelectModule}
                    />
                  </div>
                ))
              ) : (
                <DataNotFound message={dataMessage.noModules} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseModules;
